module.exports = __webpack_public_path__ + "static/media/help-disk-send-messges.baa7c85d.svg";